import React from "react"
import DoneIcon from "@material-ui/icons/Done"
import classNames from "classnames"
import classes from "./ChipSwitch.module.css"
import CustomChip from "../../atoms/CustomChip"

export interface ChipSwitchProps {
  value: boolean
  onChange: (newValue: boolean) => void
  activeIcon: React.ReactElement
  label?: React.ReactNode
  className?: string
  disabled?: boolean
}

const ChipSwitch = ({
  value,
  onChange,
  label,
  activeIcon,
  className,
  disabled,
}: ChipSwitchProps) => {
  return (
    <CustomChip
      variant={value ? "default" : "outlined"}
      // icon={value ? activeIcon : <></>}
      onClick={() => onChange(!value)}
      disabled={disabled}
      label={
        <span className={classes.label}>
          {label} {value && activeIcon}
        </span>
      }
      className={classNames(
        classes.root,
        {
          [classes.active]: value === true,
        },
        className
      )}
    />
  )
}

ChipSwitch.defaultProps = {
  activeIcon: <DoneIcon />,
}

export default ChipSwitch
